<div class="h-full w-full flex-1 overflow-hidden flex flex-col p-2">
   <div class="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
  <div class="flex flex-1 items-center justify-between gap-4">
    <div class="relative ">
      <input [(ngModel)]="search" type="text" placeholder="Search.." class="pl-8 w-full" />
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke-width="1.5" stroke="currentColor"
        class="absolute left-2 top-1/2 size-5 -translate-y-1/2 transform">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
    </div>
    <div *ngIf="trips && trips.length" class="flex flex-wrap items-center gap-2">
            <h1 class="text-xs text-nowrap text-left">
                Showing {{(50 * currentPage) - (trips.length != 50?
                (50
                -trips.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>

  <!-- Date picker -->
      <div class="flex gap-1">
        <div>
        <div>
          <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date" [readOnly]="true"
            (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
          <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
        </div>
      </div>

    <div class="relative w-48">
      <select class="w-full" [(ngModel)]="selectedStatus" (change)="selectStatus()">
        <option *ngFor="let status of statuses" [value]="status.value">
          {{ status.label }}
        </option>
      </select>
    </div>
      </div>

  </div>
</div>

    <div class="flex flex-col w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
        <div class="flow-root h-full overflow-y-auto">
            <div class="-my-2">
                <div class="inline-block min-w-full py-2 align-middle">
    
                    <table class="min-w-full border-separate border-spacing-0">
                        <thead>
                            <tr>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    #
                                </th>
    
                                <th *ngIf="selectedStatus !== 'pending'"
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Status
                                </th>

                                <th *ngIf="selectedStatus === 'pending'"
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Status
                                </th>
    
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Member</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Reference ID</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Contact No.
                                </th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Pickup Time
                                </th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Dropoff Time
                                </th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Pickup Address</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Dropoff Address</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Miles</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Space Type</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    LOS</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Appointment Type</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Created At</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    General Notes</th>
    
                            </tr>
                        </thead>
    
                        <tbody>
                            <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                *ngFor="let trip of trips | filter : search | paginate: {id: 'trip-pagination', itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems:totalResults }; let i = index">
    
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{i+1}}
                                </td>
                                <td *ngIf="selectedStatus !== 'pending'"
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <span [ngClass]="{
                                                                                    'badge-danger': trip?.status === 'cancelled' || trip?.status === 'reroute',
                                                                                    'badge-success': trip?.status !== 'cancelled' && trip?.status !== 'reroute'
                                                                                  }">{{trip.status | titlecase}}</span>
                                </td>

                                <td *ngIf="selectedStatus === 'pending'"
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <div [ngClass]="{'badge-danger': trip?.pendingStatus === 'cancelled' || trip?.pendingStatus === 'rejected',
                                    'badge-success': trip?.pendingStatus !== 'cancelled' && trip?.pendingStatus !== 'reroute'}">
                                        {{(trip.pendingStatus | titlecase) || 'N/A' }}
                                    </div>
                                </td>
    
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <!-- {{ trip.member }} -->
                                    <span>
                                        {{trip.member.displayName | titlecase}}
                                    </span>
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{ trip.reference || 'N/A' }}{{trip.suffix ? '-' + trip.suffix : '' }}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="trip?.pickup?.phoneNumber">
                                    {{trip.pickup?.phoneNumber ? trip.pickup?.phoneNumber : 'N/A'}}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{trip.pickup?.time | date : 'MM/DD/YYYY HHmm'}}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{trip.destination?.time | date : 'MM/DD/YYYY HHmm'}}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{ trip.pickup?.address?.name ? trip.pickup?.address?.name : 'N/A'}}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{ trip.destination?.address?.name}}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                     {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : '' }}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <!-- {{trip.spaceType ? trip.spaceType : 'N/A'}} -->
    
                                    <span
                                        *ngIf="preSpaceTypeList && preSpaceTypeList[trip.spaceType]">{{preSpaceTypeList[trip.spaceType].title | uppercase}}</span>
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <!-- {{trip.levelOfService ? trip.levelOfService : 'N/A'}} -->
                                    <span
                                        *ngIf="preLevelOfServiceList && preLevelOfServiceList[trip.levelOfService]">{{preLevelOfServiceList[trip.levelOfService].title
                                        | uppercase}}</span>
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <!-- {{trip.appointmentType ? trip.appointmentType : 'N/A'}} -->
                                    <span
                                        *ngIf="preAppointmentTypes && preAppointmentTypes[trip.appointmentType]">{{preAppointmentTypes[trip.appointmentType].title
                                        | titlecase}}</span>
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{trip.createdAt | date : 'MM/DD/YYYY'}}
                                </td>
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{trip.generalNotes ? trip.generalNotes : 'N/A'}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="flex justify-end">
            <pagination-controls id="trip-pagination" (pageChange)="onPageChange($event)" [maxSize]="5" [directionLinks]="true"
                [responsive]="true" [id]="'trip-pagination'">
            </pagination-controls>
        </div>
    </div>
</div>